import axiosClient from 'config/axiosClient';

const _url = '/Api/AuditLogs';
const auditLogService = {
    getPaging: (option) => {
        return axiosClient.post(_url + '/GetPaging', option);
    }
};

export default auditLogService;